<div class="flex justify-center">

    <div class="input-group relative flex flex-wrap items-stretch w-full mb-4">
      <input
        type="text"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        placeholder="Search"
        aria-label="Search"
        aria-describedby="button-addon2"
        [(ngModel)]="searchControl"
        (ngModelChange)="emitValueChange()">
    </div>

</div>
